import { FieldValues } from "react-hook-form";

import React from "react";
import FingridTestGenericInitialForm from "../shared/FingridTestGenericInitialForm";
import TestFingridAfrrPlanningsForm from "./TestFingridAfrrPlanningsForm";
import { TestTypeEnum } from "../shared/types";

const TestFingridAfrr: React.FC = () => {
  const [initialData, setInitialData] = React.useState<FieldValues | null>(null);

  const handleInitialSubmit = (data: FieldValues) => {
    setInitialData(data);
  };

  return !initialData ? (
    <FingridTestGenericInitialForm onSubmit={handleInitialSubmit} testType={TestTypeEnum.finlandAfrr} />
  ) : (
    <TestFingridAfrrPlanningsForm initialData={initialData} />
  );
};

export default TestFingridAfrr;
